import * as React from 'react'

export const IconElectricalEngine = props => (
    <svg viewBox="0 0 60 40" preserveAspectRatio="none" {...props}>
        <defs>
            <style>{'.prefix__st0{fill:#fff}'}</style>
        </defs>
        <path
            className="prefix__st0"
            d="M57.069 29.313C60 29.313 60 26.656 60 26.656 60 24 57.07 24 57.07 24H44.794v5.313h12.275zM57.069 15.847C60 15.847 60 13.191 60 13.191c0-2.657-2.931-2.657-2.931-2.657H44.794v5.313h12.275zM42.504 36.183V3.664C42.504 0 38.84 0 38.84 0h-.641c-3.665 0-3.665 3.664-3.665 3.664V6.87c-.732-.091-1.19-.091-1.19-.091h-5.588c-9.252 0-9.252 9.252-9.252 9.252v.824h-.458-.092c-.366 0-1.832-.092-2.748-.641-.916-.642-1.649-1.1-1.74-3.664.091-4.855-2.84-8.061-5.405-9.252-2.565-1.283-4.855-1.283-5.13-1.283C1.374 2.015 0 3.298 0 4.947c0 1.557 1.282 2.93 2.931 2.93h.092c.458 0 1.832.276 2.84.917.916.733 1.74 1.374 1.74 3.847-.092 4.306 2.29 7.42 4.763 8.702a12.109 12.109 0 005.588 1.375h.55V24c0 9.252 9.252 9.252 9.252 9.252h5.588c.458 0 .824 0 1.19-.092v3.115c0 3.664 3.665 3.664 3.665 3.664h.64c3.665 0 3.665-3.756 3.665-3.756z"
        />
    </svg>
);
